import "@argus/panoptes";
import "@vscode/codicons/dist/codicon.css";
import mermaid from "mermaid";
import "msc-components";
import vegaEmbed from "vega-embed";

import leroyTheme from "./leroy-plot";

// function insertJs(doc: Document, url: string) {
//   let script = doc.createElement("script");
//   script.setAttribute("type", "text/javascript");
//   script.setAttribute("src", url);
//   doc.body.appendChild(script);
// }

function embedVega(doc: Document) {
  let elems = doc.querySelectorAll<HTMLDivElement>(".vega-embed");
  elems.forEach(elem => {
    let content = elem.dataset.content;
    if (!content) throw new Error("Vega element missing content");
    let id = elem.id;
    vegaEmbed(`#${id}`, JSON.parse(content), { config: leroyTheme as any });
  });
}

window.addEventListener("DOMContentLoaded", () => {
  // insertJs(document, argusScriptUrl);
  // insertJs(document, componentScriptUrl);
  embedVega(document);
  mermaid.initialize({ startOnLoad: true });
});
